import {
	GQLOrderItemPrintDecorationType,
	GQLOrderItemPrintFragment,
	GQLOrderItemPrintSideType,
	GQLOrderItemTileFragment,
	GQLProductSideAvailableDecorationType,
	GQLProductSideSideType,
} from '@theprintbar/graphql';
import { Decoration, getDecorationName, orderedProductSides } from '..';
import { mapEnumValue } from '../..';

export function getSortedPrints(item: GQLOrderItemTileFragment) {
	return (
		item.prints?.sort((a, b) => {
			const aSide = mapEnumValue(GQLOrderItemPrintSideType, GQLProductSideSideType, a.side);
			const bSide = mapEnumValue(GQLOrderItemPrintSideType, GQLProductSideSideType, b.side);

			if (!aSide || !bSide) return 0;

			return orderedProductSides.indexOf(aSide) - orderedProductSides.indexOf(bSide);
		}) || []
	);
}

export function getOrderDecorationTypes(order: {
	items?: Array<{ prints?: Array<{ decoration: any }> | null }> | null;
}): Record<GQLOrderItemPrintDecorationType, string> {
	return (
		order.items?.reduce((acc, item) => {
			item.prints?.forEach(({ decoration }) => {
				const decorationType = decoration as GQLOrderItemPrintDecorationType;
				if (!acc[decorationType]) {
					acc[decorationType] = getDecorationName(decoration);
				}
			});
			return acc;
		}, {} as Record<GQLOrderItemPrintDecorationType, string>) || ({} as Record<GQLOrderItemPrintDecorationType, string>)
	);
}

export function getOrderItemDecorationTypes(orderItem: {
	prints?: Array<{ decoration: GQLOrderItemPrintDecorationType }> | null;
}): Record<GQLOrderItemPrintDecorationType, string> {
	return (
		orderItem.prints?.reduce((acc, { decoration }) => {
			if (!acc[decoration]) {
				acc[decoration] = getDecorationName(decoration);
			}
			return acc;
		}, {} as Record<GQLOrderItemPrintDecorationType, string>) || ({} as Record<GQLOrderItemPrintDecorationType, string>)
	);
}

export function orderItemPrintToDecoration(print: GQLOrderItemPrintFragment): Decoration {
	return {
		type: mapEnumValue(GQLOrderItemPrintDecorationType, GQLProductSideAvailableDecorationType, print.decoration)!,
		side: mapEnumValue(GQLOrderItemPrintSideType, GQLProductSideSideType, print.side)!,
		artwork: new Blob(), // Not used for pricing, so can be an empty blob
		meta: {
			width: print.width,
			height: print.height,
			left: print.left,
			top: print.top,
			centreOffset: print.centreOffset,
			requestedColours: print.requestedColours,
			stitches: print.stitches,
			colours: [],
			percentages: {
				width: 0,
				height: 0,
				left: 0,
				top: 0,
				centreOffset: 0,
			},
		},
	};
}
